import { Typography } from "@mui/material";
import React from "react";
import { themes, fonts } from "../themes/themes";

interface employeeDesignation {
  designation?: string;
  isDashboard?: boolean;
}
const EmployeeDesignation: React.FC<employeeDesignation> = ({
  designation,
  isDashboard = false,
}) => {
  return designation && designation !== undefined ? (
    <Typography
      style={{
        color: themes.greySubtitle,
        fontSize: fonts.subtitle,
        fontFamily: fonts.fontFamily,
      }}
    >
      {designation}
    </Typography>
  ) : (
    <></>
  );
};
export default EmployeeDesignation;
